import React, { useState } from 'react'
import * as R from 'ramda'
import { useIntl } from 'react-intl'
import { Typography } from '@material-ui/core'
import CountryRegionData from 'country-region-data'

import { isEmptyOrNil } from 'libs/empty'
import effects from 'app/effects/effects'
import Assets from 'app/configs/assetConfigs'

import { PlanBillingShipping } from './PlanBillingShipping'
import { PlanBillingPositiveActionBar } from './PlanBillingActionBar'
import PlanBillingDetailsFormDialog from './PlanBillingDetailsFormDialog'

const orderedCustomerInformation = [
  'fullName',
  'address1',
  'address2',
  'city:state:country:zipCode',
  'countryCode;phoneNumber',
]

export const PlanBillingDetails = ({
  isPhysicalWebStarterPack,
  billingAddress,
  shippingAddress,
  handleSubmit,
}) => {
  const { formatMessage } = useIntl()
  const [isOpenBillingDetailsDialog, setIsOpenBillingDetailsDialog] =
    useState(false)
  const handleBillingAddress = {
    ...billingAddress,
    fullName: `${billingAddress.firstName} ${billingAddress.lastName}`,
  }

  const handleSubmitBillingDetails = async (data) => {
    await effects.apis.updateBillingAddress(data)
    handleSubmit()
    setIsOpenBillingDetailsDialog(false)
  }

  return (
    <>
      <PlanBillingPositiveActionBar
        text={formatMessage({
          id: 'planAndBilling.billingDetails.label',
        })}
        buttonText={formatMessage({ id: 'action.update' })}
        onClick={() => setIsOpenBillingDetailsDialog(true)}
        buttonProps={{
          className:
            'bg-white self-start text-blue-primary border-solid border-1 border-blue-primary shadow-0',
          'data-testid': 'changeBillingAddressButton',
        }}
      />
      <div className="space-y-3 my-5">
        <PlaceDetailsInformation billingAddress={handleBillingAddress} />
      </div>
      {isPhysicalWebStarterPack ? (
        <PlanBillingShipping
          shippingAddress={shippingAddress}
          onSubmit={() => handleSubmit()}
        />
      ) : null}
      <PlanBillingDetailsFormDialog
        initialValue={billingAddress}
        isOpen={isOpenBillingDetailsDialog}
        onClose={() => setIsOpenBillingDetailsDialog(false)}
        onSubmit={handleSubmitBillingDetails}
      />
    </>
  )
}

export const PlaceDetailsInformation = ({ billingAddress }) => {
  return orderedCustomerInformation.map(mapPlaceInfo(billingAddress))
}

const mapPlaceInfo = (billingAddress) => (key) => {
  const iconAddress = {
    fullName: 'name',
    address1: 'address',
  }

  const getBillingAddressProp = (key) => {
    if (key === 'country')
      return R.compose(
        R.prop('countryName'),
        R.find(R.propEq('countryShortCode', R.prop(key, billingAddress))),
      )(CountryRegionData)
    return R.prop(key, billingAddress)
  }

  if (key.includes(';')) {
    if (!getBillingAddressProp('phoneNumber')) {
      return ''
    }

    const text = key
      .split(';')
      .map(getBillingAddressProp)
      .filter(Boolean)
      .join('')

    const result = (
      <div key={key} className="flex space-x-3 items-start">
        <img
          src={Assets.billingAddress.phoneIcon}
          alt="billing_address_phone"
          width={20}
        />
        <Typography>{text}</Typography>
      </div>
    )
    return result
  }

  if (key.includes(':')) {
    const text = key
      .split(':')
      .map(getBillingAddressProp)
      .filter(Boolean)
      .join(', ')

    const result = (
      <div className="ml-28">
        <Typography key={key}>{text}</Typography>
      </div>
    )

    return result
  }

  if (isEmptyOrNil(getBillingAddressProp(key))) return null

  const result = (
    <div key={key} className="flex space-x-3 items-start">
      {key === 'address2' ? null : (
        <img
          src={Assets.billingAddress[iconAddress[key]]}
          alt={`billing_address_${key}`}
          width={20}
        />
      )}
      <div className="ml-28">
        <Typography>{getBillingAddressProp(key)}</Typography>
      </div>
    </div>
  )
  return result
}
